import { useEffect, useState } from "react";
import Title from "../../../componente/cadastro/titulo/index.jsx";
import Description from "../../../componente/cadastro/descricao/index.jsx";
import Table from "../../../componente/cadastro/tabela/index.jsx";
import Table2 from "../../../componente/cadastro/tabela/index.jsx";
import Pagination from "../../../componente/cadastro/paginacao/index.jsx";
import Sidebar from "../../../componente/sidebar/index.jsx";
import "./style.css";
import api from "../../../services/api.js";
import { useAppContext } from "../../context/AppContext.jsx";
import { toast } from "react-hot-toast";
import * as XLSX from "xlsx";
import Impressora from "../../../assets/Impressora.png";
import ImgXLS from "../../../assets/XLS.png";
import { usePermissoes } from "../../../componente/permissoes.js";

const RelRecebimentoPorMoeda = () => {
    const { podeImprimir } = usePermissoes();

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(50);
    const [data, setData] = useState([]);
    const [detalhes, setDetalhes] = useState([]);
    const [pagination, setPagination] = useState({
        total: 0,
        totalPages: 0,
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const { accessKey, codassinante, usuario, codempresa } = useAppContext();

    const [moedaSelecionada, setMoedaSelecionada] = useState(null);

    const getFirstDayOfMonth = () => {
        const dt = new Date();
        dt.setMonth(dt.getMonth()); // retrocede 1 mês
        return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-01`;
    };

    // Função para calcular a data atual + 2 meses
    const getCurrentDate = () => {
        const dt = new Date();
        dt.setMonth(dt.getMonth()); // avança 2 meses
        return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-${dt.getDate().toString().padStart(2, "0")}`;
    };

    // filtros    
    const [dataInicio, setDataInicio] = useState(getFirstDayOfMonth());
    const [dataFim, setDataFim] = useState(getCurrentDate());

    const columnsMaster = [{ key: "moeda", title: "Condição de Pagamento" },
    { key: "qtde", title: "Qtde Registros" },
    { key: "total", title: "Total Arrecadado", type: "float" }];

    const columnsDetail = [{ key: "codcontasreceber", title: "Código" },
    { key: "numpedido", title: "Núm. Pedido" },
    { key: "dtvencimento", title: "Vencimento", type: "date" },
    { key: "dtbaixa", title: "Baixa", type: "datetime" },
    { key: "cliente", title: "Cliente" },
    { key: "vlliquido", title: "Valor", type: "float" }];

    const fetchMoedas = async () => {
        try {
            setLoading(true);
            setError(null);

            const params = {
                codassinante,
                data_inicio: dataInicio,
                data_fim: dataFim,
                codempresa
            };

            const response = await api.get("/v1/relatorio/recebimentomoeda", {
                params,
                headers: {
                    Authorization: `Bearer ${accessKey}`
                }
            });

            const moedas = response.data.data || [];

            setData(moedas);

            if (moedas.length > 0) {
                selecionarMoeda(moedas[0]);
            }

        } catch (error) {
            console.error(error);
            toast.error("Erro ao carregar dados ❌");
        } finally {
            setLoading(false);
        }
    };

    const fetchDetalhes = async (codMoeda) => {
        try {
            setLoading(true);
            const params = {
                codassinante,
                codempresa,
                codmoeda: codMoeda,
                data_inicio: dataInicio,
                data_fim: dataFim,
                page: currentPage,
                per_page: perPage
            };

            const response = await api.get(
                "/v1/relatorio/recebimentomoeda/detalhes",
                {
                    params,
                    headers: {
                        Authorization: `Bearer ${accessKey}`
                    }
                }
            );
            setDetalhes(response.data.data || []);
            setPagination({
                total: response.data.pagination.Total,
                totalPages: response.data.pagination.TotalPages
            });
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMoedas();
    }, [
        dataInicio,
        dataFim
    ]);

    useEffect(() => {
        if (moedaSelecionada) {
            fetchDetalhes(moedaSelecionada.codmoeda);
        }
    }, [
        currentPage,
        perPage
    ]);

    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
        setCurrentPage(1);
    };

    const exportToExcel = async () => {
        try {
            const workbook = XLSX.utils.book_new();
            const rows = [];
            for (const moeda of data) {
                // Cabeçalho da moeda
                rows.push({
                    Moeda: moeda.moeda,
                    Qtde: moeda.qtde,
                    Total: moeda.total
                });

                // Cabeçalho dos detalhes
                rows.push({
                    Código: "Código",
                    Pedido: "Pedido",
                    Cliente: "Cliente",
                    Vencimento: "Vencimento",
                    Baixa: "Baixa",
                    Valor: "Valor"
                });

                // Busca os detalhes
                const response = await api.get(
                    "/v1/relatorio/recebimentomoeda/detalhes",
                    {
                        params: {
                            codassinante,
                            codempresa,
                            codmoeda: moeda.codmoeda,
                            data_inicio: dataInicio,
                            data_fim: dataFim,
                            page: 1,
                            per_page: 999999
                        },
                        headers: {
                            Authorization: `Bearer ${accessKey}`
                        }
                    }
                );

                response.data.data.forEach(item => {
                    rows.push({
                        Código: item.codcontasreceber,
                        Pedido: item.numpedido,
                        Cliente: item.cliente,
                        Vencimento: item.dtvencimento,
                        Baixa: item.dtbaixa,
                        Valor: item.vlliquido
                    });
                });
                rows.push({});
                rows.push({});
            }
            const worksheet = XLSX.utils.json_to_sheet(rows);

            XLSX.utils.book_append_sheet(
                workbook,
                worksheet,
                "Recebimento por Moeda"
            );

            XLSX.writeFile(
                workbook,
                "Relatorio_Recebimento_Por_Moeda.xlsx"
            );

        } catch (err) {
            console.log(err);
            toast.error("Erro ao exportar Excel");
        }
    };

    const imprimir = async () => {
        setLoading(true);
        try {

            // prepara parâmetros
            const params = {
                codassinante,
                data_inicio: dataInicio,
                data_fim: dataFim,
                codempresa,
                usuario
            };

            const response = await api.get("/v1/impressoes/relatorio/recebimentopormoeda", {
                responseType: "arraybuffer",
                params,
                headers: { Authorization: `Bearer ${accessKey}` },
            });

            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            link.click();
        } catch (error) {
            console.error("Erro ao imprimir:", error);
            toast.error("Erro ao gerar PDF ❌");
        } finally {
            setLoading(false);
        }
    };

    const selecionarMoeda = (item) => {
        setMoedaSelecionada(item);
        setCurrentPage(1);
        fetchDetalhes(item.codmoeda);
    };

    return (
        <div className="app-container">
            <Sidebar />
            <main className="content-container">
                <div className="container-fluid py-4 d-flex flex-column" style={{ minHeight: "100vh" }}>
                    <Title text="Relatório de Recebimento Por Moeda" icon="shopping-cart" />
                    <Description text="Relatório que lista os recebimentos por data e moeda" />

                    {/* FILTROS */}
                    <div className="card p-3 mb-3 shadow-sm">
                        <div className="row g-3">

                            {/* Filtro de data inicio e fim */}
                            <>
                                <div className="col-md-2">
                                    <label className="form-label">Início</label>
                                    <input type="date" className="form-control" value={dataInicio} onChange={(e) => setDataInicio(e.target.value)} />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label">Fim</label>
                                    <input type="date" className="form-control" value={dataFim} onChange={(e) => setDataFim(e.target.value)} />
                                </div>
                            </>
                        </div>

                        <div className="mt-3 d-flex justify-content-end gap-2">
                            <button disabled={!podeImprimir("/rel/relrecebimentopormoeda")} className="btn btn-primary d-flex align-items-center gap-2" onClick={imprimir}>
                                <img src={Impressora} alt="Imprimir" width="20" /> Imprimir
                            </button>
                            <button disabled={!podeImprimir("/rel/relrecebimentopormoeda")} className="btn btn-outline-success d-flex align-items-center gap-2" onClick={exportToExcel}>
                                <img src={ImgXLS} alt="Excel" width="20" /> Excel
                            </button>
                        </div>
                    </div>

                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error}
                        </div>
                    )}

                    {/* TABELA */}
                    <div className="flex-grow-1 d-flex flex-column">
                        {loading ? (
                            <div className="text-center py-4">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Carregando...</span>
                                </div>
                            </div>
                        ) : (
                            <div className="table-wrapper flex-grow-1 d-flex flex-column">
                                <Table
                                    columns={columnsMaster}
                                    data={data}
                                    onRowClick={selecionarMoeda}
                                    selectedRow={moedaSelecionada?.codmoeda}
                                />
                                <Table2
                                    columns={columnsDetail}
                                    data={detalhes}
                                    showFooter={true}
                                />
                            </div>
                        )}
                    </div>

                    {/* PAGINAÇÃO */}
                    <Pagination
                        currentPage={currentPage}
                        totalPages={pagination.totalPages}
                        onPageChange={setCurrentPage}
                        perPage={perPage}
                        onPerPageChange={handlePerPageChange}
                        total={pagination.total}
                    />
                </div>
            </main>
        </div>
    );
};

export default RelRecebimentoPorMoeda;
